import { ItemList } from "../../orm";

class AdminGalleriesList extends ItemList {

  getEntityKey() {
    return "admin/gallery";
  }

}

export const adminGalleriesList = new AdminGalleriesList("admin_galleries__default");
